/**
 * LengthUnit class
 *
 *     const lengthUnit = new LengthUnit("inch", 0.0393701);
 *
 * An object that encapsulates the identifier and conversion factor for a length unit.
 */
export default class LengthUnit {
    /**
     * @property string identifier
     * Identifier for the length unit.
     */
    identifier = null;

    /**
     * @property float conversionFactor
     * Conversion factor of the length unit.
     */
    conversionFactor = null;

    constructor(identifier, conversionFactor) {
        this.identifier = identifier;
        this.conversionFactor = conversionFactor;
    }

    /**
     * Returns the length unit identifier.
     *
     *  @return {string}
     */
    getIdentifier() {
        return this.identifier;
    }

    /**
     * Returns the length unit conversion factor.
     *
     *  @return {number}
     */
    getConversionFactor() {
        return this.conversionFactor;
    }
}
